import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber,
} from 'antd';
import ReactQuill, { Quill } from 'react-quill';
import Parameters from 'shared/parameters';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    UploadOutlined,
    ArrowLeftOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadImage } from 'shared/services/Utility';
import { fillEn } from '../../methods/forms';
import arrowLeft from '../../../src/img/arrow-left.png';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';

interface Props {
    location: any;
    hideHeader?: boolean
}

const { Title } = Typography;
const { Option } = Select;
export default function CurriculumForm(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [item, setItem] = useState(null as any);
    const [uploading, setUploading] = useState(false);
    const [courseAuthorId, setCourseAuthorId] = useState(null as any);
    const [selectedLang, setSelectedLang] = useState('en' as any);
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchCurriculumByIdAdmin(RouteParams['courseId'], RouteParams['id']);
            setItem({
                ...data,
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    const refreshCourseItem = async () => {
        try {
          setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchCourseByIdAdmin(RouteParams['courseId']);
            setCourseAuthorId(data.author.id)
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
          setFetching(false);
        }
    };

    useEffect(() => {
        if (RouteParams['courseId']) {
            refreshCourseItem();
        }
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
        let localLang = localStorage.getItem("language")
        if(localLang != undefined && localLang != null && localLang != ''){
            setSelectedLang(localLang)
        }
    }, []);

    if (fetching) {
        return <Skeleton active={true}/>;
    }
    return (
        <AuthConsumer>
      {({ user }) => (
          (user?.id == courseAuthorId) || user?.role?.id == 2 || courseAuthorId == null && (user?.role?.slug !== 'STUDENT') ?
          <>
          <div className='d-md-flex'>
                <FrontendSidebar menuSelect={2} />

                <div className={Parameters.Mode === 'CLIENT' ? 'profile-tab-content-div mb-3' : 'mb-3'} style={{ width: '100%' }}>
                    <div className={Parameters.Mode !== 'CLIENT' ? 'container-fluid' : ''}>
                        {RouteParams['mode'] != 'view' && <div className={props.hideHeader ? '' : 'list-page-wrapper'}>
                            {!props.hideHeader && <>
                                <div className='row mb-3'>
                                    <div className='col-md-12 p-0 d-flex align-items-center'>
                                        <div className='mr-4'>
                                            <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                        </div>
                                        <div><h3 className='mb-0'>{RouteParams['mode'] === 'create' ? t('curriculum.create') : ''}</h3></div>
                                        <div><h3 className='mb-0'>{RouteParams['mode'] === 'view' ? t('curriculum.profile') : ''}</h3></div>
                                        <div><h3 className='mb-0'>{RouteParams['mode'] === 'edit' ? t('curriculum.edit') : ''}</h3></div>
                                    </div>
                                </div>
                            </>}
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='bg-white p-3 br-5px'>
                                        <div className="row">
                                            <div className="col-md-12 pt-3 pb-3">
                                                <div className="form-fields pl-4 pr-6rem">
                                                    <fieldset>
                                                        <Form
                                                            size="large"
                                                            form={form}
                                                            initialValues={item}
                                                            fields={[]}
                                                            onFinish={(value) => {

                                                                const reqObj: any = fillEn(value);
                                                                setSaving(true);
                                                                if (item && item.id) {
                                                                    API_SERVICE.updateCurriculum(RouteParams['courseId'], item.id, reqObj).then((d) => {
                                                                        history.goBack();
                                                                    }).catch((e) => {
                                                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                        setSaving(false);
                                                                    });
                                                                } else {
                                                                    API_SERVICE.createCurriculum(RouteParams['courseId'], reqObj).then((d) => {
                                                                        history.goBack();
                                                                    }).catch((e) => {
                                                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                        setSaving(false);
                                                                    });
                                                                }
                                                            } }
                                                            layout="vertical"
                                                            requiredMark={true}
                                                        >
                                                            <div className="row">
                                                                <div className="col-md-5">
                                                                    <h5>{t('genDict.ModuleInformation')}</h5>
                                                                    <p className="text-secondary">{t('genDict.CourseInformationParagraph')}</p>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <Form.Item
                                                                        label={t('title.label')}
                                                                        name={['title', selectedLang]}
                                                                        rules={[
                                                                            { required: true, message: t('title.required') },
                                                                        ]}
                                                                    >
                                                                        <Input className='br-1' disabled={!RouteParams['mode']} />
                                                                    </Form.Item>
                                                                    {/* <Form.Item
                                                                        label={t('curriculum.title.label')}
                                                                        name={['title', 'en']}
                                                                        rules={[
                                                                        ]}>
                                                                        <Input className='br-1' disabled={!RouteParams['mode']} />
                                                                    </Form.Item> */}
                                                                    <Form.Item
                                                                        label={t('description.label')}
                                                                        name={['description', selectedLang]}
                                                                        rules={[
                                                                            { required: true, message: t('description.required') },
                                                                        ]}
                                                                    >
                                                                        <Input className='br-1' disabled={!RouteParams['mode']} />
                                                                    </Form.Item>
                                                                    {/* <Form.Item
                                                                        label={t('curriculum.description.label')}
                                                                        name={['description', 'en']}
                                                                        rules={[]}>
                                                                        <Input className='br-1' disabled={!RouteParams['mode']} />
                                                                    </Form.Item> */}
                                                                    <Form.Item
                                                                        label={t('curriculum.sortOrder.label')}
                                                                        name={'sort_order'}
                                                                        initialValue={item ? item.sort_order : 0}
                                                                        rules={[]}>
                                                                        <InputNumber className='br-1' min={0} disabled={!RouteParams['mode']} />
                                                                    </Form.Item>
                                                                </div>
                                                            </div>

                                                            <hr></hr>

                                                            {RouteParams['mode'] && RouteParams['mode'] != 'view' && <Form.Item>
                                                                <Button
                                                                    htmlType="submit"
                                                                    loading={saving || uploading}
                                                                    size={'large'}
                                                                    className="submit btn-blue float-right"
                                                                >
                                                                    {t('genDict.save')}
                                                                </Button>
                                                                <Button
                                                                    htmlType="reset"
                                                                    size={'large'}
                                                                    className="reset mr-3 btn-default float-right"
                                                                >
                                                                   {t('genDict.cancel')}
                                                                </Button>
                                                            </Form.Item>}
                                                        </Form>
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
            <Form
                size="large"
                form={form}
                initialValues={item}
                fields={[]}
                onFinish={(value) => {

                    const reqObj: any = fillEn(value);
                    setSaving(true);
                    if (item && item.id) {
                        API_SERVICE.updateCurriculum(RouteParams['courseId'], item.id, reqObj).then((d) => {
                            history.goBack();
                        }).catch((e) => {
                            notification.error({ message: API_SERVICE.handleErrors(e) });
                            setSaving(false);
                        });
                    } else {
                        API_SERVICE.createCurriculum(RouteParams['courseId'], reqObj).then((d) => {
                            history.goBack();
                        }).catch((e) => {
                            notification.error({ message: API_SERVICE.handleErrors(e) });
                            setSaving(false);
                        });
                    }
                }}
                layout="vertical"
                requiredMark={true}
            >

                <Form.Item
                    label={t('curriculum.titleDe.label')}
                    name={['title', 'de']}
                    rules={[
                        { required: true, message: t('curriculum.titleDe.required') },
                    ]}
                >
                    <Input disabled={!RouteParams['mode']}/>
                </Form.Item>
                <Form.Item
                    label={t('curriculum.title.label')}
                    name={['title', 'en']}
                    rules={[
                        // { required: true, message: t('curriculum.titleDe.required') },
                    ]}>
                    <Input disabled={!RouteParams['mode']}/>
                </Form.Item>
                <Form.Item
                    label={t('curriculum.descriptionDe.label')}
                    name={['description', 'de']}
                    rules={[
                        { required: true, message: t('curriculum.descriptionDe.required') },
                    ]}
                >
                    <Input disabled={!RouteParams['mode']}/>
                </Form.Item>
                <Form.Item
                    label={t('curriculum.description.label')}
                    name={['description', 'en']}
                    rules={[
                        // { required: true, message: t('curriculum.descriptionDe.required') },
                    ]}>
                    <Input disabled={!RouteParams['mode']}/>
                </Form.Item>
                <Form.Item
                    label={t('curriculum.sortOrder.label')}
                    name={'sort_order'}
                    initialValue={item ? item.sort_order : 0}
                    rules={[]}>
                    <InputNumber min={0} disabled={!RouteParams['mode']}/>
                </Form.Item>
                <br/>
                {
                    RouteParams['mode'] && <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={saving || uploading}
                            shape="round"
                            size={'large'}
                            className="submit"
                        >
                            {t('genDict.save')}
                        </Button>
                    </Form.Item>
                }
            </Form>
        </Col>
    </Row> */}
                        </div>}
                    </div>
                </div>
            </div>
            </>
        : <><div>
        {setFetching(true)}
        <h5 className="text-center mt-5 mb-5">{t('genDict.PermissionDenied')}</h5>
        {setFetching(false)}
    </div>
</>
)}
</AuthConsumer>
    );
}
